// FTEDN Creator — Bottom Tab Bar (Mobile Navigation)
import { useLocation, useNavigate } from 'react-router-dom';
import './BottomTabBar.css';

const TABS = [
  { icon: '🏠', label: 'Home', path: '/dashboard' },
  { icon: '🧪', label: 'Lab', path: '/lab' },
  { icon: '+', label: '', path: '/beta', isCenter: true },
  { icon: '💬', label: 'Chat', path: '/community', badge: 4 },
  { icon: '👤', label: 'You', path: '/alerts' },
];

export function BottomTabBar() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav className="bottom-tab-bar" id="bottom-nav">
      {TABS.map((tab) => (
        <button
          key={tab.path}
          className={`tab-item ${tab.isCenter ? 'tab-center' : ''} ${location.pathname === tab.path ? 'active' : ''}`}
          onClick={() => navigate(tab.path)}
          id={`tab-${tab.label.toLowerCase() || 'create'}`}
        >
          {tab.isCenter ? (
            <span className="tab-center-icon">+</span>
          ) : (
            <>
              <span className="tab-icon">{tab.icon}</span>
              {tab.badge && tab.badge > 0 && (
                <span className="tab-badge">{tab.badge}</span>
              )}
              <span className="tab-label">{tab.label}</span>
            </>
          )}
        </button>
      ))}
    </nav>
  );
}
